export const SEGMENTED_EXPERIENCE_VARIANT = 'osc-segmented-experience'

export const isSegmentedExperience = item => item?.layoutVariant === SEGMENTED_EXPERIENCE_VARIANT
